import { render, staticRenderFns } from "./FeedType.vue?vue&type=template&id=09a41bea&scoped=true"
import script from "./FeedType.vue?vue&type=script&lang=js"
export * from "./FeedType.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09a41bea",
  null
  
)

export default component.exports